module.exports = __webpack_public_path__ + "img/template1.cfdaba0f.png";